import { type ReactNode, useContext } from "react";
import "./GoToSettings.scss";
import { useTranslation } from "react-i18next";
import type { Page } from "@/shared/model/pages-management/ApplicationPages.ts";
import IconGear from "@/shared/components/generic/icons/IconGear.tsx";
import { AppUserInfoContext } from "@/shared/model/user/AppUserInfoContext.ts";

interface Properties {
  targetPage: Page;
}

export default function GoToSettings(props: Properties): ReactNode {
  const { t } = useTranslation();
  const userInfo = useContext(AppUserInfoContext);

  return (
    props.targetPage.userCanAccess(userInfo) && (
      <a href={props.targetPage.buildUrl()} className="go-to-settings">
        <div>{t("goToSettings")}</div>
        <IconGear />
      </a>
    )
  );
}
